<template>
  <v-dialog v-model="shown" persistent width="500px" scrollable>
    <v-card>
      <v-card-title class="headline">{{ original ? $t('profile.certForm.titleUpdate') : $t('profile.certForm.titleAdd') }}</v-card-title>
      <v-divider />
      <v-card-text @drop.stop="drop">
        <v-layout row wrap>
          <v-flex xs6>
          <v-text-field
            :label="$t('headers.name')"
            v-model="name"
          />
          </v-flex>
          <v-flex xs4>
            <v-switch v-model="enabled" :label="$t('headers.enabled')" class="ml-3" />
          </v-flex>
        </v-layout>

        <div v-show="original === null">
          <v-text-field
            label="Klíč"
            multi-line
            v-model="certificate"
            :rules="keyRules"
          />

          <input type="file" ref="file" @change="fileChanged" />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="red--text darken-1" flat="flat" @click.native="shown = false">{{ $t('cancel') }}</v-btn>
        <v-btn class="green--text darken-1" flat="flat" @click.native="save" :loading="isBusy">{{ $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UserCertificate from '../../models/UserCertificate'

export default {
  data () {
    return {
      shown: false,
      isBusy: false,
      name: null,
      certificate: null,
      enabled: true,
      original: null,
      keyRules: [
        (value) => {
          if (!value) return true
          return /-----BEGIN PGP PUBLIC KEY BLOCK-----([^]*?)-----END PGP PUBLIC KEY BLOCK-----/.test(value)
            ? true
            : this.$t('configuration.basic.invalidKey')
        }
      ]
    }
  },
  methods: {
    show (original) {
      this.original = original || null
      this.$refs.file.value = null
      this.name = this.original ? this.original.name : null
      this.certificate = null
      this.enabled = this.original ? this.original.enabled : true
      this.shown = true
    },
    save () {
      this.isBusy = true
      this.doSave()
      .then(item => {
        this.$emit('saved', item)
        this.isBusy = false
        this.shown = false
      }).catch(error => {
        console.error(error)

        this.isBusy = false

        if (error.response.data && error.response.data.errors) {
          if (error.response.data.errors.find(err => err.property === 'certificate')) {
            alert(this.$t('configuration.basic.invalidKey'))
            return
          }
        }

        console.error(error.response)

        alert(this.$t('savingFailed'))
      })
    },
    doSave () {
      if (this.original) {
        this.original.name = this.name
        this.original.enabled = this.enabled
        return UserCertificate.update(this.original, [ 'name', 'enabled' ])
      } else {
        return UserCertificate.create({
          name: this.name,
          certificate: this.certificate,
          enabled: this.enabled
        })
      }
    },
    drop (ev) {
      let data = ev.dataTransfer
      if (data.items) {
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].kind === 'file') {
            this.readFile(data.items[i].getAsFile())
            ev.preventDefault()
            break
          }
        }
      } else {
        this.readFile(data.files[0])
        ev.preventDefault()
      }
    },
    fileChanged () {
      if (this.$refs.file.files && this.$refs.file.files.length === 1) {
        this.readFile(this.$refs.file.files[0])
      }
    },
    readFile (file) {
      let reader = new FileReader()
      reader.onload = () => {
        if (!this.name) {
          this.name = file.name
        }
        this.certificate = reader.result
      }
      reader.readAsText(file)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// CertificateForm.vue?74d62cbf